$(function () {
  var $container = null;
  var $trigger = null;
  var $popup = $('.hover_bkgr_fricc');
  $('.trigger_popup_fricc').on('click', function (event) {
    $trigger = $(event.currentTarget);
    $container = $trigger.parents('.prop-65').find('.hover_bkgr_fricc').first();
    $popup.show();

    if ($container.length === 0) {
      console.warn('Unable to find container to trap focus');
      return;
    }

    window.slate.a11y.trapFocus({
      $container: $container,
      $elementToFocus: $('a, [tabindex]', $container).first()
    });
  });
  $popup.on('keyup', function (event) {
    if (event.key === 'Escape') {
      hidePopup();
    }
  });
  $('.popupCloseButton').on('click', hidePopup).on('keydown', function (event) {
    if (event.which === 13) {
      hidePopup();
    }
  });

  function hidePopup() {
    $popup.hide();

    if ($container) {
      window.slate.a11y.removeTrapFocus({
        $container: $container,
        $elementToFocus: $trigger
      });
    }
  }
});